import hlsl from "refractor/hlsl";
export default hlsl;